import React from 'react';

import { ReactDataTableTitle } from '@metarouter-private/mr-mui';

export const UserInvitationsTableTitle = () => {
  const label = 'User Invites';
  return <ReactDataTableTitle label={label} />;
};
